import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listInvitations, createInvitation } from '@/api/invitations';
import type { CreateInvitationInput } from '@/types/invitation';

export function useInvitations() {
  return useQuery({
    queryKey: ['teachers', 'invitations'],
    queryFn: listInvitations,
  });
}

export function useCreateInvitation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input?: CreateInvitationInput) => createInvitation(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teachers', 'invitations'] });
    },
  });
}
